import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react'
import moment from 'moment-timezone'
import { getPrintPreview } from './utils'
import Switch from './formElements/Switch'
import ExploriDatePicker from './formElements/DatePicker'

const dateFormat = 'YYYY-MM-DD'

@observer
class Date extends Component {
    constructor(props) {
        super(props)

        const { question } = props

        if (question.settings.frontend.switch) {
            this.switchValue = question.settings.frontend.switch[0]
        } else {
            this.switchValue = undefined
        }
    }

    handleStartChange = (inputValue) => {
        const { question, store, formId } = this.props
        const { form_data } = store
        const questionId = question.id
        const canUpdate = true

        console.log(`handleChange ${moment(inputValue).format(dateFormat)}`)
        const data = Object.assign({}, form_data.has(questionId) ? form_data.get(questionId).data : {
            switch: this.switchValue,
            formId,
        })
        data.startDate = moment(inputValue).format(dateFormat)

        if (canUpdate) {
            store.addFormResponse(question, data)
        }
    }

    handleEndChange = (inputValue) => {
        const { question, store, formId } = this.props
        const { form_data } = store
        const questionId = question.id
        const canUpdate = true

        console.log(`handleChange ${moment(inputValue).format(dateFormat)}`)
        const data = Object.assign({}, form_data.has(questionId) ? form_data.get(questionId).data : {
            switch: this.switchValue,
            formId,
        })
        data.endDate = moment(inputValue).format(dateFormat)

        if (canUpdate) {
            store.addFormResponse(question, data)
        }
    }

    preFix = () => {
        const { question, store } = this.props
        let elem = null

        if (question.settings.frontend.prefix) {
            elem = <div style={{ marginRight: '10px' }}>{store.prePostFix(question, 'prefix')}</div>
        }

        return elem
    }

    postFix = () => {
        const { question, store } = this.props
        let elem = null

        if (question.settings.frontend.postfix) {
            elem = <div style={{ marginLeft: '10px' }}>{store.prePostFix(question, 'postfix')}</div>
        }

        return elem
    }

    changeSwitch = (e) => {
        const { question, store } = this.props
        const { form_data, langcode } = store
        const { defaultLocale } = store.data.metadata
        const { initialLocale } = question

        const questionId = question.id
        const { checked } = e.target
        const switchValue = checked
            ? question.settings.frontend.switch[1]
            : question.settings.frontend.switch[0]

        let localeLabel = ''
        if (switchValue[langcode]) {
            localeLabel = switchValue[langcode].text
        } else if (switchValue[defaultLocale]) {
            localeLabel = switchValue[defaultLocale].text
        } else if (switchValue[initialLocale]) {
            localeLabel = switchValue[initialLocale].text
        }

        this.switchValue = localeLabel

        if (form_data.has(questionId)) {
            const { data } = form_data.get(questionId)
            data.switch = localeLabel
            store.addFormResponse(question, data)
        }
    }

    getSwitchLabel = (target) => {
        const { question, store } = this.props
        const { langcode } = store
        const { defaultLocale } = store.data.metadata
        const { initialLocale } = question

        const index = target === 'left'
            ? 0
            : 1

        const switchValue = question.settings.frontend.switch[index]

        let localeLabel = ''
        if (switchValue[langcode]) {
            localeLabel = switchValue[langcode].text
        } else if (switchValue[defaultLocale]) {
            localeLabel = switchValue[defaultLocale].text
        } else if (switchValue[initialLocale]) {
            localeLabel = switchValue[initialLocale].text
        }

        return localeLabel
    }

    getPlaceholderLabel = (target) => {
        const { question, store } = this.props
        const { langcode } = store
        const { defaultLocale } = store.data.metadata
        const { initialLocale } = question

        const index = target === 'left'
            ? 0
            : 1

        const switchValue = question.settings.frontend.placeHolder[index]

        let localeLabel = ''
        if (switchValue[langcode]) {
            localeLabel = switchValue[langcode].text
        } else if (switchValue[defaultLocale]) {
            localeLabel = switchValue[defaultLocale].text
        } else if (switchValue[initialLocale]) {
            localeLabel = switchValue[initialLocale].text
        }

        return store.replaceOptionMerge(localeLabel)
    }

    render() {
        const { question, store, validationMsg } = this.props
        const { form_data } = store
        const questionId = question.id
        const { minDate, maxDate } = question
        const data = form_data.has(questionId) ? form_data.get(questionId).data : { startDate: '', endData: '' }
        const { startDate, endDate } = data
        console.log(`FORM ${JSON.stringify(form_data, null, 4)}`)
        console.log(`FORM ${startDate}, ${endDate}`)
        return (
            <div style={{
                display: 'flex', justifyContent: 'space-between', alignContent: 'center', gap: '10px',
            }}>
                {getPrintPreview(question, store)}
                {this.preFix()}
                <ExploriDatePicker
                    dateOnly
                    minDate={minDate ? moment(minDate) : null}
                    maxDate={maxDate ? moment(maxDate) : null}
                    dateTimeText={startDate ? moment(startDate) : undefined}
                    dateTimeFormat="YYYY-MM-DD"
                    placeholder={this.getPlaceholderLabel('left')}
                    onChange={this.handleStartChange}
                />
                {question.settings.frontend.renderType === 'DR' && (
                    <Fragment>
                        <ExploriDatePicker
                            dateOnly
                            minDate={minDate ? moment(minDate) : null}
                            maxDate={maxDate ? moment(maxDate) : null}
                            dateTimeFormat="YYYY-MM-DD"
                            placeholder={this.getPlaceholderLabel('right')}
                            dateTimeText={endDate ? moment(endDate) : undefined}
                            onChange={this.handleEndChange}
                        />
                    </Fragment>
                )}
                {validationMsg}
                {this.postFix()}
                {question.settings.frontend.switch && (
                    <Switch
                        value={data.switch}
                        left={this.getSwitchLabel('left')}
                        right={this.getSwitchLabel('right')}
                        onChange={this.changeSwitch}
                    />
                )}
            </div>
        )
    }
}

export default Date
